import React from 'react';
import {
    Box, Grid,
    Typography,
} from "@mui/material";
import {useSelector} from "react-redux";
import { alpha } from '@mui/material/styles';

export const AuthLayoutScreen = ({children}) => {

    const title = 'Roster management';
    const subtitle = 'Your centralized platform for all roster needs.';
    const logoUrl = useSelector((state) => state.app.config?.logo_url) || '/images/logo.png';
    const finalLogoUrl = logoUrl;

    return (
        <Grid container sx={{ height: '100vh', display: 'flex' }}> {/* Height ko 100vh par set kiya */}
            {/* Left side: Image and Branding */}
            <Grid item xs={12} sm={4} md={12} lg={7} className="auth-layout-screen-left"
                  sx={{
                      backgroundImage: 'url(../../images/banner.webp)',
                      backgroundRepeat: 'no-repeat',
                      backgroundColor: (t) => t.palette.mode === 'light' ? t.palette.grey[600] : t.palette.grey[900],
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      position: 'relative',
                      display: {  sm: 'flex', md: 'flex' },
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      p: 4
                  }}
            >
                {/* Overlay layer */}
                <Box sx={{
                    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: (theme) => alpha(theme.appBar.backgroundColor, 0.8),
                    zIndex: 1
                }} />

                {/* Main Content Box with Higher Z-index */}
                <Box sx={{ zIndex: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flexGrow: 1 }}>
                    {/* Top-left Branding Section */}
                    <Box>
                        <Box component="img" src={finalLogoUrl} alt={"ADNEC Logo"} className="logo-light" sx={{ maxWidth: '180px', height: 'auto', maxHeight: '60px', mb: 1 }} />
                    </Box>
                    {/* Middle Welcome Text */}
                    <Box sx={{ my: 'auto' }}>
                        <Typography variant="h1" sx={{ fontSize: {md: '3.2rem', xs: '1.4rem'}, fontWeight: 'bold', color: 'white' }}>
                            {title}
                        </Typography>
                        <Typography variant="body1" sx={{ fontSize: {md: '1.2rem', xs: '0.95rem'}, color: 'white', mt: 1 }}>
                            {subtitle}
                        </Typography>
                    </Box>
                    {/* Footer Section */}
                    <Box sx={{ mt: 'auto' }}>
                        <Typography variant="caption" sx={{ display: 'block', color: 'white', opacity: 0.8 }}>
                            Copyright © 2026 ADNEC Group. All rights reserved.
                        </Typography>
                    </Box>
                </Box>
            </Grid>

            {/* Right side: Dynamic Content */}
            <Grid item xs={12} sm={8} md={12} lg={5}
                  sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                  }}
            >
                <Box sx={{
                    maxWidth: { lg: '500px', md: '450px', sm: '400px', xs: '400px' },
                    width: '100%',
                    px: 4, // Horizontal padding
                    py: 6, // Vertical padding
                }}>
                    {children}
                </Box>
            </Grid>
        </Grid>
    )
}